import React, { Component } from 'react';
import { MDBBtn, MDBCard, MDBCardBody, MDBIcon, MDBRow, MDBCol, MDBCardText } from 'mdbreact';


class DashboardCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            flipped: false
        }

    }

    handleFlipping = () => {
        this.setState({ flipped: !this.state.flipped });
    }



    render() {
        let diff = ((this.props.currentValue - this.props.previousValue) / this.props.previousValue) * 100;
        let increase = diff >= 0 ? true : false;
        let width = diff + '%';
        diff = Math.abs(diff).toFixed();

        return (
            <div>
                {this.state.flipped ? (
                    <MDBCard className="cascading-admin-card">
                        <div className="admin-up">
                            <MDBIcon icon={this.props.iconName} style={{ backgroundColor: "grey" }} />
                            <div className="data">
                                <h5><strong>{this.props.cardName}</strong></h5>
                                <p><strong>Previous Segment</strong></p>
                            </div>
                        </div>
                        {this.props.cardType == "Team_Recruits" ? (<MDBCardBody>
                            <MDBRow>
                                <MDBCol sm="4" xs="4" className="mb-r">
                                    <p>{this.props.value1Description} <br />

                                        <strong>{this.props.previousValue1}</strong>
                                    </p>

                                </MDBCol>
                                <MDBCol sm="4" xs="4" className="mb-r">
                                    <p>{this.props.value2Description} <br />

                                        <strong>{this.props.previousValue2}</strong>
                                    </p>
                                </MDBCol>
                                <MDBCol sm="4" xs="4" className="mb-r">
                                    <p>{this.props.value3Description} <br />

                                        <strong>{this.props.previousValue3}</strong>
                                    </p>
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol sm="12" className="mb-r text-center">
                                    <a href="#!" className="rotate-btn" data-card="card-1" onClick={this.handleFlipping}>
                                        <MDBIcon icon="redo" /> Click For Current Segment
                                    </a>
                                </MDBCol>
                            </MDBRow>
                        </MDBCardBody >): (<MDBCardBody>
                            <MDBRow>
                                <MDBCol sm="6" xs="6" className="mb-r">
                                    <p>{this.props.value1Description} <br />

                        <strong>{this.props.previousValue1}</strong>
                                    </p>

                                </MDBCol>
                                <MDBCol sm="6" xs="6" className="mb-r">
                    <p>{this.props.value2Description} <br />

                        <strong>{this.props.previousValue2}</strong>
                    </p>
                </MDBCol>
                            </MDBRow>
            <MDBRow>
                <MDBCol sm="12" className="mb-r text-center">
                    <a href="#!" className="rotate-btn" data-card="card-1" onClick={this.handleFlipping}>
                        <MDBIcon icon="redo" /> Click For Current Segment
                                    </a>
                </MDBCol>
            </MDBRow>
                        </MDBCardBody >)
    }

                    </MDBCard>

                ) : (

                        <MDBCard className="cascading-admin-card">
                            <div className="admin-up">
                                <MDBIcon icon={this.props.iconName} style={{ backgroundColor: this.props.iconColor }} />
                                <div className="data">
                                    <h5><strong>{this.props.cardName}</strong></h5>
                                    <p><strong>Current Segment</strong></p>
                                </div>
                            </div>
                            {this.props.cardType == "Team_Recruits" ? (<MDBCardBody>
                                <MDBRow>
                                    <MDBCol sm="4" xs="4" className="mb-r">
                                        <p>{this.props.value1Description} <br />

                                            <strong>{this.props.currentValue1}</strong>
                                        </p>

                                    </MDBCol>
                                    <MDBCol sm="4" xs="4" className="mb-r">
                                        <p>{this.props.value2Description} <br />

                                            <strong>{this.props.currentValue2}</strong>
                                        </p>
                                    </MDBCol>
                                    <MDBCol sm="4" xs="4" className="mb-r">
                                        <p>{this.props.value3Description} <br />

                                            <strong>{this.props.currentValue3}</strong>
                                        </p>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol sm="12" className="mb-r text-center">
                                        <a href="#!" className="rotate-btn" data-card="card-1" onClick={this.handleFlipping}>
                                            <MDBIcon icon="redo" /> Click For Prev. Segment
                        </a>
                                    </MDBCol>
                                </MDBRow>
                            </MDBCardBody>) : (<MDBCardBody>
                                <MDBRow>
                                    <MDBCol sm="6" xs="6" className="mb-r">
                                        <p>{this.props.value1Description} <br />

                                            <strong>{this.props.currentValue1}</strong>
                                        </p>

                                    </MDBCol>
                                    <MDBCol sm="6" xs="6" className="mb-r">
                                        <p>{this.props.value2Description} <br />

                                            <strong>{this.props.currentValue2}</strong>
                                        </p>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol sm="12" className="mb-r text-center">
                                        <a href="#!" className="rotate-btn" data-card="card-1" onClick={this.handleFlipping}>
                                            <MDBIcon icon="redo" /> Click For Prev. Segment
                        </a>
                                    </MDBCol>
                                </MDBRow>
                            </MDBCardBody>)}
                            

                        </MDBCard>

                    )}
            </div>
        )
    }
}

export default DashboardCard;